import React from 'react';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { createThemeOverride } from '@/style/theme';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { useGetThemePortalProps } from '@/hooks/useGetThemePortalProps';

type Props = {
  children: React.ReactNode;
};

export const Theme = ({ children }: Props) => {
  const { portalTheme } = useGetThemePortalProps();

  const themeOverride = createThemeOverride(portalTheme);
  const theme = createTheme('uhc', themeOverride);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
